import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "center" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className="eyebrow flex items-center gap-3 justify-center">
        <span className="hairline w-10 inline-block" />
        {eyebrow}
        <span className="hairline w-10 inline-block" />
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-5 leading-tight text-[#F8F9FA]">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p className="mt-5 text-[#C5CEE0] text-base sm:text-lg leading-relaxed font-light">{sub}</p>
      </Reveal>
    )}
  </div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
